export interface ShowImageData {
    image_id: string
    image_url: string
    is_cover: boolean
}

export interface Contributor {
    role: string
    responsible: string
}

export interface Show {
    show_id: string
    org_id: string
    cover_image: string
    name: string
    description: string
    genre: string
    contributors: Contributor[]
}

export interface ShowDTO {
    coverImage: string
    name: string
    description: string
    genre: string
    contributors: Contributor[]
}

export interface ShowWithImages extends Show {
    images: ShowImageData[]
}

export interface ShowWithImagesDTO extends ShowDTO {
    images: ShowImageData[]
}

export const mapShowToDTO = (show: Show): ShowDTO => ({
    coverImage: show.cover_image,
    name: show.name,
    description: show.description,
    genre: show.genre,
    contributors: show.contributors,
})

export const mapShowWithImagesToDTO = (show: ShowWithImages): ShowWithImagesDTO => ({
    coverImage: show.cover_image,
    name: show.name,
    description: show.description,
    genre: show.genre,
    contributors: show.contributors,
    images: show.images,
})

export const mapDTOToShow = (dto: ShowDTO, show_id: string, org_id: string): Show => ({
    show_id,
    org_id,
    cover_image: dto.coverImage,
    name: dto.name,
    description: dto.description,
    genre: dto.genre,
    contributors: dto.contributors,
})
